// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"KN-z","carouselContainer":"LN-z"};